import logo from './logo.svg';
import './App.css';
import './Responsive.css'
import 'bootstrap/dist/css/bootstrap.min.css';

import Login from './Pages/Login';

function App() {
  return (
    <div className="App">

      <Login/>
      
    </div>
  );
}

export default App;
